module.exports = __webpack_public_path__ + "assets/img/56b.182afb6a.png";